import { db } from "../utils/firestore";
import {
  doc,
  getDoc,
  collection,
  addDoc,
  getDocs,
  updateDoc,
  // deleteDoc,
  query,
  orderBy,
  where,
  startAfter,
  endBefore,
  limit,
  setDoc,
  getCountFromServer,
} from "firebase/firestore";
import { generateTrigam } from "../utils/trigamUtils";

//const dbCollection = db.collection("/usersgroups");

class UsersGroupsService {
  //import { db } from '../utils/firestore'; // update with your path to firestore config
  //import { doc, getDoc } from "firebase/firestore";

  getOne = async (id) => {
    try {
      if (id) {
        // //console.log(id);
        const noteSnapshot = await getDoc(doc(db, "usersgroups", id));
        if (noteSnapshot.exists()) {
          if (noteSnapshot.data().metadataactive) {
            return noteSnapshot.data();
          } else {
            throw new Error("Registro não encontrado!");
          }
        } else {
          throw new Error("Registro não encontrado!");
        }
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  };
  //usage: getNote(id);

  getAll = async () => {
    const querySnapshot = await getDocs(query(collection(db, "usersgroups"), where("metadataactive", "==", true), orderBy("name", "asc")));
    return querySnapshot.docs;
  };

  getCollectionSize = async () => {
    // const querySnapshot = await getDocs(query(collection(db, "usersgroups"), where("metadataactive", "==", true), orderBy("name", "asc")));
    // return querySnapshot.docs.length;
    const q = query(collection(db, "usersgroups"), where("metadataactive", "==", true));
    const snapshot = await getCountFromServer(q);
    //console.log("count: ", snapshot.data().count);
    return snapshot.data().count;
  };

  getFilteredCollection = async (filterTarget, operation, filterValue) => {
    let querySnapshot = {};
    //console.log(filterTarget, operation, filterValue);
    if (filterTarget === "name")
      querySnapshot = await getDocs(
        query(collection(db, "usersgroups"), where(filterTarget, operation, filterValue), orderBy("name", "asc"))
      );
    else
      querySnapshot = await getDocs(
        query(collection(db, "usersgroups"), where(filterTarget, operation, filterValue), orderBy("name", filterTarget, "asc"))
      );
    return querySnapshot.docs;
  };

  getCollectionSearchByPrefix = async (queryTarget, queryText) => {
    //console.log(queryTarget, queryText);
    let conditions = [];
    if (queryText.length > 0) {
      if (["%", "*", "?"].includes(queryText.substring(0, 1))) {
        queryText = queryText.substring(1, queryText.length);
        queryText = queryText.trim().toLowerCase().replaceAll("  ", " ");
        conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText).slice(0, 10)]));
        if (queryText.searchInfo) {
          if (queryText.searchInfo.length > 0) conditions.push(orderBy(queryTarget, "asc"));
        }
      } else {
        queryTarget = queryTarget.replace("trigam", "name");
        conditions.push(where(queryTarget, ">=", queryText));
        conditions.push(where(queryTarget, "<=", queryText + "\uf8ff"));
      }
    }

    // let trigamQuery = generateTrigam(queryText);
    // if (trigamQuery.length >= 10) {
    //   const querySnapshot = await getDocs(
    //     query(
    //       collection(db, "usersgroups"),
    //       where("name", ">=", queryText),
    //       where("name", "<=", queryText + "\uf8ff"),
    //       orderBy("name", "asc")
    //     )
    //   );
    //   return querySnapshot.docs;
    // } else {
    //   const querySnapshot = await getDocs(
    //     query(collection(db, "usersgroups"), where(queryTarget, "array-contains-any", [...trigamQuery]), orderBy("name", "asc"))
    //   );
    //   return querySnapshot.docs;
    // }
    //console.log("conditions=", conditions);
    const querySnapshot = await getDocs(query(collection(db, "usersgroups"), ...conditions));
    return querySnapshot.docs;
  };

  getPrevPage = async (firstVisible, pageSize) => {
    let querySnapshot = await getDocs(
      query(
        collection(db, "usersgroups"),
        where("metadataactive", "==", true),
        orderBy("name", "asc"),
        limit(pageSize),
        endBefore(firstVisible)
      )
    );
    return querySnapshot.docs;
  };

  getNextPage = async (lastVisible, pageSize) => {
    let querySnapshot = null;
    if (lastVisible !== null) {
      querySnapshot = await getDocs(
        query(
          collection(db, "usersgroups"),
          where("metadataactive", "==", true),
          orderBy("name", "asc"),
          limit(pageSize),
          startAfter(lastVisible)
        )
      );
    } else {
      querySnapshot = await getDocs(
        query(collection(db, "usersgroups"), where("metadataactive", "==", true), orderBy("name", "asc"), limit(pageSize))
      );
    }
    return querySnapshot.docs;
  };

  create = async (value) => {
    value = { ...value, trigam: generateTrigam(value.name) };
    return await addDoc(collection(db, "usersgroups"), value);
  };

  update = async (id, value) => {
    try {
      // await updateDoc(doc(db, "usersgroups", id), { metadataactive: false });
      // return await addDoc(collection(db, "usersgroups"), value);
      value = { ...value, trigam: generateTrigam(value.name) };
      return setDoc(doc(db, "usersgroups", id.toString()), value);
    } catch (error) {
      throw error;
    }
  };

  updateActiveState = async (id, newStateValue) => {
    try {
      return await updateDoc(doc(db, "usersgroups", id), {
        metadataactive: newStateValue,
      });
    } catch (error) {
      throw error;
    }
  };

  delete = async (id) => {
    this.update(id, { metadataactive: false });
  };

}

export default new UsersGroupsService();
